import Markdown from 'react-markdown'
import { Heading as BaseHeading, HeadingProps } from 'blaze-ui/Heading/Heading'
import { TextMessageRendererProps } from '../Types'
import { Children, PropsWithChildren, ReactNode } from 'react'
import Styles from './TextMessageRenderer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Paragraph as BaseParagraph } from 'blaze-ui/Paragraph/Paragraph'
import cx from 'classnames'
import { UnorderedListProps } from 'react-markdown/lib/ast-to-react'
import { parseHexCodes } from 'components/HexCodeDisplayer/parseHexCodes'

const processChildren = (children: ReactNode): ReactNode =>
  Children.map(children, (child) => (typeof child === 'string' ? parseHexCodes(child) : child))

const Heading = ({ children, ...props }: PropsWithChildren<HeadingProps>) => (
  <div className={cx(Styles.headingContainer, Styles[`level${props.level}`])}>
    <BaseHeading {...props}>{children}</BaseHeading>
  </div>
)

const Ul = ({ children, ...props }: PropsWithChildren<UnorderedListProps>) => (
  <ul className={cx(Styles.ul, Styles[`depth${props.depth}`])}>{children}</ul>
)

const Li = ({ children, isNextGen }: PropsWithChildren<{ isNextGen?: boolean }>) => (
  <li className={Styles.li}>
    <Text variant={isNextGen ? 'primary' : 'secondary'} color={isNextGen ? undefined : 'var(--dark-80)'}>
      {processChildren(children)}
    </Text>
  </li>
)
const Paragraph = ({ children, isNextGen }: PropsWithChildren<{ isNextGen?: boolean }>) => (
  <div className={Styles.paragraph}>
    <BaseParagraph variant={isNextGen ? 'primary' : 'secondary'} color={isNextGen ? undefined : 'var(--dark-80)'}>
      {processChildren(children)}
    </BaseParagraph>
  </div>
)

export const TextMessageRenderer = ({ children, isNextGen }: TextMessageRendererProps) => {
  return (
    <Markdown
      components={{
        h1({ children }) {
          return <Heading level={1}>{children}</Heading>
        },
        h2({ children }) {
          return <Heading level={2}>{children}</Heading>
        },
        h3({ children }) {
          return <Heading level={3}>{children}</Heading>
        },
        h4({ children }) {
          return <Heading level={4}>{children}</Heading>
        },
        h5({ children }) {
          return <Heading level={5}>{children}</Heading>
        },
        ul({ children, ...props }) {
          return <Ul {...props}>{children}</Ul>
        },
        li({ children }) {
          return <Li isNextGen={isNextGen}>{children}</Li>
        },
        p({ children }) {
          return <Paragraph isNextGen={isNextGen}>{children}</Paragraph>
        },
        hr() {
          return <hr className={Styles.hr} />
        },
      }}
    >
      {children}
    </Markdown>
  )
}
